import {
    whatsappQRCodeUrl,
    whatsappStatusUrl,
    whatsappConnectUrl,
    whatsappReconnectUrl,
    whatsappDisconnectUrl
} from "../config";

// Get QR Code for WhatsApp connection
export const getWhatsAppQRCode = async (userPhone) => {
    try {
        const url = new URL(whatsappQRCodeUrl);
        url.searchParams.set('userPhone', userPhone);
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to get QR code");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to get QR code");
    }
};

// Get WhatsApp connection status
export const getWhatsAppStatus = async (userPhone) => {
    try {
        const url = new URL(whatsappStatusUrl);
        url.searchParams.set('userPhone', userPhone);
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to get status");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to get status");
    }
};

// Connect WhatsApp
export const connectWhatsApp = async (userPhone) => {
    try {
        const response = await fetch(whatsappConnectUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userPhone })
        });
        
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to connect");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to connect");
    }
};

// Reconnect WhatsApp
export const reconnectWhatsApp = async (userPhone) => {
    try {
        const response = await fetch(whatsappReconnectUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userPhone })
        });
        
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to reconnect");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to reconnect");
    }
};

// Disconnect WhatsApp
export const disconnectWhatsApp = async (userPhone) => {
    try {
        const response = await fetch(whatsappDisconnectUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userPhone })
        });
        
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to disconnect");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to disconnect");
    }
};

